import { Typography } from "@mui/material";
import { Link } from "@arp/react-ndbx";
import { URLS } from "../const/enums";

// import useSharedData from "../../hooks/useSharedData.ts";

//** NOTE: This file needs to be of type .jsx as we may need to pass React objects to the frontend */

export const yourDetailsPersonalNotification = {
	NUMBER_OF_PEOPLE_NOTIFICATION: {
		cardType: "info",
		title: "Number of people insured",
		message:
			"As you have selected the option to insure an additional adult, you will be required to fill in your details and then the second applicants details to move into the select cover step.",
	},
	PERMANENT_RESIDENT_NOTIFICATION: {
		cardType: "error",
		title: "Permanent Residency",
		additionalText: "Note:",
		message: (
			<>
				This product is only available to Permanent Residents of Australia.{" "}
				<br /> <br />
				For the purposes of providing insurance, a Permanent Resident of
				Australia is an Australian Citizen or a New Zealand Citizen or a holder
				of an Australian Permanent Residency Visa who's currently permanently
				residing within Australia.
			</>
		),
	},
};

export const yourDetailsContactNotification = ({ pdsURL = null }) => {
	const notificationInfo = {
		LIFE_INSURANCE_TYPE_NOTIFICATION: {
			name: "life",
			cardType: "info",
			title: "Maximum limit for multiple Allianz Life policies",
			message: (
				<>
					A maximum limit applies to the Cover Amount that can be held across
					multiple Life Insurance policies with Allianz. Refer to the{" "}
					<Link href={pdsURL} target="_blank">
						Product Disclosure Statement
					</Link>{" "}
					‘How much cover can I apply for?’ And the ‘Maximum benefits payable’
					sections for more details. You can call us on{" "}
					<Link href={URLS.CONTACT_US_PHONE_URL}>
						{URLS.CONTACT_US_PHONE_NUMBER}
					</Link>{" "}
					if you’d like to be assessed for additional cover or increased cover
					amounts on your existing policy. We can provide you with a quote and
					explain the process.
				</>
			),
		},

		CONTACT_NUMBER_INFORMATION_NOTIFICATION: {
			name: "contactNumber",
			cardType: "info",
			title: "Important information",
			message:
				"Ensure your mobile number is entered correctly as it'll be used to secure your information and verify your identity at a later date. We’ll be using this number to send you a verification code when you proceed or retrieve your saved application.",
		},
	};
	return { notificationInfo };
};
// export const yourDetailsContactNotification = {
// 	/**
//    * Below is not referenced currently
//    * If need to be used again, update the reference of PDS_URL to use the dynamic one inside sharedData

//   LIFE_INSURANCE_TYPE_NOTIFICATION: {
//     name: "life",
//     cardType: "info",
//     title: "Maximum limit for multiple Allianz Life policies",
//     message: (
//       <>
//         A maximum limit applies to the Cover Amount that can be held across
//         multiple Life Insurance policies with Allianz. Refer to the{" "}
//         <Link href={URLS.PDS_URL} target="_blank">
//           Product Disclosure Statement
//         </Link>{" "}
//         ‘How much cover can I apply for?’ And the ‘Maximum benefits payable’
//         sections for more details. You can call us on{" "}
//         <Link href={URLS.CONTACT_US_PHONE_URL}>
//           {URLS.CONTACT_US_PHONE_NUMBER}
//         </Link>{" "}
//         if you’d like to be assessed for additional cover or increased cover
//         amounts on your existing policy. We can provide you with a quote and
//         explain the process.
//       </>
//     ),
//   },
//   */

// 	CONTACT_NUMBER_INFORMATION_NOTIFICATION: {
// 		name: "contactNumber",
// 		cardType: "info",
// 		title: "Important information",
// 		message:
// 			"Ensure your mobile number is entered correctly as it'll be used to secure your information and verify your identity at a later date. We’ll be using this number to send you a verification code when you proceed or retrieve your saved application.",
// 	},
// };

export const paymentContactDetailsNotification = {
	EMAIL_POLICY_INFO_NOTIFICATION: {
		name: "emailInfo",
		cardType: "info",
		title: "",
		message:
			"As the customer has chosen not to be provided their policy information via email, this correspondence will be sent to their nominated address provided.",
	},
	PAYMENT_GATEWAY_ERROR: {
		cardType: "error",
		title: "Try again",
		message:
			"Unfortunately we’ve experienced an error while processing your payment. Save your quote and re-attempt your payment in 2 hours, or use an alternative card or bank account to make your payment.",
	},
};

export const paymentDetailsNotification = {
	GRANT_PERMISSION_DENY_NOTIFICATION: {
		name: "grantPermissionInfo",
		cardType: "error",
		title: "Permission to deduct funds",
		message:
			"You haven't given us permission to deduct from your bank account. Choose an alternative payment method to continue.",
	},
};

export const additionalInformationNotification = {
	ADDITIONAL_INFORMATION_NOTIFICATION: {
		name: "additionalExclusionInfo",
		cardType: "warning",
		title: "Additional Information",
		message:
			"You are about to edit the cover details for the customer via a Premium increase or Exclusions.",
	},
	ADDITIONAL_INFORMATION_WARNING: {
		name: "additionalExclusionWarning",
		cardType: "error",
		title: null,
		message:
			"Only authorised staff are allowed to process Additional information changes.",
	},
};

export const dodIndividualCoverNotification = {
	INDIVIDUAL_COVER_NOTIFICATION: {
		cardType: "error",
		title: "Completing personally as an individual",
		message: (
			<>
				Applicants must complete the ‘About You’ questions themselves,
				personally, and for their own coverage as an individual.
				<Typography sx={{ mb: 1 }}></Typography>
				This product can only be purchased and owned by an individual. This
				product isn't suitable for purchase or ownership within a superannuation
				fund. We encourage you to speak to your financial planner or accountant
				who may be able to provide you with advice should you be seeking an
				alternative Life Insured, Policy Ownership and/or payment arrangement.
			</>
		),
	},
};

//* Payment page navigation Notifications
export const paymentNavigationContactDetails = {
	CONTACT_DETAILS_NAVIGATION: {
		cardType: "info",
		title:
			"You are one step away from insuring the most important thing in your life - you.",
		message: (
			<>
				Now is your opportunity to ensure that you are happy with your cover,
				sums insured and to check all your contact details are correct.
				<br />
				<br />
				Once you have proceeded to the payment page you cannot navigate back. 
			</>
		),
	},
};

export const paymentNavigationPaymentDetails = {
	PAYMENT_DETAILS_NAVIGATION: {
		cardType: "info",
		title: "Nearly there!",
		message: (
			<>
				You are now on the final page of your quote.
				<br />
				<br />
				Please do not attempt to navigate back from this page as you will not be
				able to do so.
				<br />
				<br />
				If you need to make any changes to your cover or any details you have
				provided, you will be required to start a new quote. 
			</>
		),
	},
};
